import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { TPartnerForm } from "@/features/rso/types/partnerForm";
import { InnerBox } from "@/components/elements/InnerBox";
import { Grid } from "@mui/material";
import { Textarea } from "@/components/elements/Textarea";
import { FormField } from "@/components/elements/FormField";

type TOtherInfoFormProps = {};
export const OtherInfoForm: FC<TOtherInfoFormProps> = () => {
  const methods = useFormContext<TPartnerForm>();
  const { control } = methods;

  return (
    <InnerBox title="その他（顧客未開示の情報）">
      <Grid container rowSpacing={2} columnSpacing={3}>
        <Grid item xs={6}>
          <FormField control={control} name="description" label="紹介会社情報">
            <Textarea />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField control={control} name="note" label="備考">
            <Textarea />
          </FormField>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
